import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v1/profiles', { params });
  },
  getPosition() {
    return axios.get('/v1/position/list-position');
  },
  getPermission() {
    return axios.get('/v1/permission/list-permission');
  },
  detail({ id }) {
    return axios.get(`/v1/profile/detail/${id}`);
  },
  create(data) {
    return axios.post('/v1/profile/create', data);
  },
  update(id, params) {
    return axios.post(`/v1/profile/update/${id}`, params);
  }
};
